
/*
  This component will display steps in configurator
 */

import React from 'react'
import { useSelector } from "react-redux";
import PatternSide from "./PatternSide";

const PatternStep = (props) => {

    const sideAttributes = useSelector(state => state.patternSelectionsReducer.sides)

    const generateKey = (type, id) => {
        return `configurator_pattern_${type}_${id}_${ new Date().getTime() }`;
    }

    const patternSteps = () => {
        const steps = [];
        // set options to aan array to run through, position 0 will be the key
        // const attrArr = Object.entries(props.options);
        // since corners are always last, we need to move them to the front
        // optionArr.unshift(optionArr.pop())
        // set first pattern hash so we can use spread operator on store
        sideAttributes.forEach(function(patternSide, index){
            const key = Object.keys(patternSide)[0];
            steps.push(
                <PatternSide key={generateKey('side', index)} sideKey={key} sideData={patternSide} corner={key == 'CORNER'} />
            )
        })

        return steps;
    }

    return (
        <div className="configurator-count">
            { patternSteps() }
        </div>
    )
}

export default PatternStep;
